import { render, staticRenderFns } from "./ComplianceRunning.vue?vue&type=template&id=2f1ae8b0&"
import script from "./ComplianceRunning.vue?vue&type=script&lang=js&"
export * from "./ComplianceRunning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports